import React, { useRef } from 'react';
import cn from 'classnames';
import Select from 'react-select';
import './styles.scss';
import Element from '../Element';
import View from '../View';
import { isEmpty } from 'src/validations';
import { getRandomId } from 'src/utils';

const SelectCmp = ({
  options,
  onChange,
  label,
  className = '',
  value,
  errorMessage = '',
  placeholder = 'Select',
  containerClassName,
  ...props
}) => {
  const id = useRef(`input-${getRandomId()}`);
  const handleChange = selectedOption => {
    onChange(selectedOption?.value);
  };

  const hasError = !isEmpty(errorMessage);

  const selectedOption = options?.find(option => option.value === value) || null;
  // For custom select, follow this link:
  // https://react-select.com/styles#using-classnames
  return (
    <Element id={id} errorMessage={errorMessage} label={label} className={containerClassName}>
      <View>
        <Select
          isClearable={true}
          value={selectedOption}
          placeholder={placeholder}
          onChange={handleChange}
          options={options}
          className={cn('cmp-select', className)}
          classNamePrefix="cmp-select"
          menuPlacement="auto"
          theme={theme => ({
            ...theme,
            colors: {
              ...theme.colors,
              primary: '#22767c',
              neutral20: hasError ? '#c60000' : 'hsl(0, 0%, 80%)',
            },
          })}
          {...props}
        />
      </View>
    </Element>
  );
};

export default SelectCmp;
